import { Checkbox, useTheme } from '@mui/material';
import { useRowSelectionContext } from 'components/atoms/RowSelectionContext';
import React from 'react';

interface Props {
  id: string | number;
}

const CardCheckbox = ({ id }: Props) => {
  const { isRowSelected, toggleSelection } = useRowSelectionContext();
  const theme = useTheme();

  return (
    <Checkbox
      data-cy={`card-checkbox-${id}`}
      disableRipple
      sx={{
        backgroundColor: 'transparent !important',
        color: theme.palette.common.white,
        p: 1,
        borderRadius: 0,
        position: 'absolute',
        top: 5,
        left: 5,
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '& .MuiSvgIcon-root': {
          filter: 'drop-shadow(0 0 2px rgba(0, 0, 0, 0.75))',
        },
        '&.Mui-checked': {
          color: theme.palette.primary.main,
        },
      }}
      checked={isRowSelected(id)}
      onClick={(e) => {
        e.stopPropagation();
        toggleSelection(id);
      }}
    />
  );
};

export default CardCheckbox;
